import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
    selector: '[transitionReset]',
})
export class TransitionResetDirective {
    constructor(private el: ElementRef) {}

    @HostListener('click') onMouseEnter() {
        this.resetAnimate();
    }

    private resetAnimate(): void {
        const parentClasses = this.el.nativeElement.parentNode.classList;
        let timeout;

        for (let hasClass of parentClasses) {
            if (hasClass !== 'nav-expanded') {
                this.el.nativeElement.nextElementSibling.style.transition = 'margin-left 0s ease .0s';
                timeout = setTimeout(() => {
                    this.el.nativeElement.nextElementSibling.style = '';
                    clearTimeout(timeout);
                }, 100);
            }
        }
    }
}
